import { createSelector } from 'reselect'
import { selectCurrentPhoneId } from '../App/selectors'

const selectRouting = (state) => state.routing.locationBeforeTransitions

const selectHighlight = createSelector(
  selectCurrentPhoneId,
  selectRouting,
  (phoneId, routing) =>
    phoneId === null &&
    (routing.pathname === '/tutorials' || routing.pathname === '/faqs')
)

const selectLocation = createSelector(
  selectRouting,
  (routing) => routing.pathname
)

export { selectHighlight, selectLocation }
